export default theme => ({
    container: base => ({
      ...base,
      position: 'relative',
      marginRight: 0,
    }),
    control: base => ({
      ...base,
      borderRadius: 0,
      padding: '1px',
      border: '1px solid #d8d8d8',
      minHeight: 'unset',
      boxShadow: 'unset',
      '&:hover': {
        boxShadow: 'unset'
      },
      '@media (min-width: 901px)': {
        padding: '6px',
      }
    }),
    indicatorSeparator: base => ({
      display: 'none'
    }),
    SingleValue: base => ({
      ...base,
      color: 'red'
    }),
    menu: base => ({
      ...base,
      marginTop: 0,
      borderRadius: 0,
      zIndex: 499,
      boxShadow: '0 4px 2px -2px hsla(0,0%,0%,0.1), 0 4px 11px hsla(0,0%,0%,0.1)',
      textAlign: 'center'
    }),
    menuList: base => {
      return {
        ...base,
        width: 'auto',
        overflowX: 'hidden',
        maxHeight: '140px'
      };
    },
    indicatorsContainer: base => {
      return {
        ...base,
        position: 'absolute',
        top: 0,
        right: -4,
        left: 'auto',
        bottom: 0,
        '&:lang(ar)': {
          right: 'auto',
          left: '-4px'
        },
      };
    },
    dropdownIndicator: (base, state) => ({
        ...base,
        transition: "all .2s ease",
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
        cursor: "pointer",
        color: theme,
        '&:hover': {
            color: theme
        }
      })
  });